(function () {
    'use strict';

    function togglePanel(button) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        var isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
            panel.style.setProperty('--tv-panel-height', panel.scrollHeight + 'px');
            void panel.offsetHeight;
            panel.style.setProperty('--tv-panel-height', '0px');
            button.setAttribute('aria-expanded', 'false');
            panel.addEventListener('transitionend', function handler() {
                panel.hidden = true;
                panel.removeEventListener('transitionend', handler);
            });
        } else {
            panel.hidden = false;
            panel.style.setProperty('--tv-panel-height', panel.scrollHeight + 'px');
            button.setAttribute('aria-expanded', 'true');
        }
    }

    document.addEventListener('click', function (e) {
        var button = e.target.closest('.tv-faqs__header');
        if (!button) return;
        togglePanel(button);
    });
})();
